import $ from 'jquery';

export default function globalNotificationModule() {
  const globalNotificationElement = $('.global-notification');
  if (globalNotificationElement.length) {
    return import(/* webpackChunkName: "global-notification" */ '../globalNotification')
      .then(({ default: GlobalNotification }) => {
        const globalNotification = new GlobalNotification();
        return globalNotification;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
